// Time in milliseconds
export const firstTextTimeOut = 2000;
export const secondTextTimeOut = 3000;
export const thirdTextTimeOut = 4000;
export const isProgressingTimeOut = 7000;
export const isDoneTimeOut = 3000;
